import { type ContractCallType } from '@/types';

import {
  METHOD_SET_FUNDRAISING_DURATION,
  METHOD_SET_INTEREST_RATE,
  METHOD_SET_MAX_FUNDRAISING_AMOUNT,
  METHOD_SET_MIN_FUNDRAISING_AMOUNT,
  METHOD_SET_OPERATING_DURATION,
  METHOD_SET_POOL_DESCRIPTION,
  METHOD_SET_POOL_NAME,
  METHOD_SET_STAKING_TOKEN,
  METHOD_SETMINSTAKEAMOUNT,
  METHOD_STOP_FUNDRAISING,
  COIN_NAME_SFL,
} from '../common/name-space';
import type EthereumRpc from './evm.web3';

// TODO symbol 고정이 아닌 동적으로
export default class EtherContractCall {
  private rpc: EthereumRpc;

  constructor(rpc: EthereumRpc) {
    this.rpc = rpc;
  }

  async handleContractCall(obj: ContractCallType) {
    await this.rpc?.contractStakingCall<any>(obj);
  }

  async setPoolName(aTitle: string) {
    const obj: ContractCallType = {
      method: METHOD_SET_POOL_NAME,
      symbol: COIN_NAME_SFL,
      data: { _name: aTitle },
    };
    await this.handleContractCall(obj);
  }
  async setPoolDescription(aDescription: string) {
    const obj: ContractCallType = {
      method: METHOD_SET_POOL_DESCRIPTION,
      symbol: COIN_NAME_SFL,
      data: { _description: aDescription },
    };
    await this.handleContractCall(obj);
  }
  async setMinStakeAmount(aAmount: string) {
    const obj: ContractCallType = {
      method: METHOD_SETMINSTAKEAMOUNT,
      symbol: COIN_NAME_SFL,
      data: { _amount: aAmount },
    };
    await this.handleContractCall(obj);
  }
  async setInterestRate(aInterestRate: string) {
    const obj: ContractCallType = {
      method: METHOD_SET_INTEREST_RATE,
      symbol: COIN_NAME_SFL,
      data: { _interestRate: aInterestRate },
    };
    await this.handleContractCall(obj);
  }
  // TODO 시작 종료을 구해서 값을 가져와 체크
  async setFundraisingDuration(aStartDt: string, aEndDt: string) {
    const re = `${aStartDt}${aEndDt}`;
    const obj: ContractCallType = {
      method: METHOD_SET_FUNDRAISING_DURATION,
      symbol: COIN_NAME_SFL,
      data: { _duration: re },
    };
    await this.handleContractCall(obj);
  }
  // TODO 시작 종료을 구해서 값을 가져와 체크
  async setOperatingDuration(aStartDt: string, aEndDt: string) {
    const re = `${aStartDt}${aEndDt}`;
    const obj: ContractCallType = {
      method: METHOD_SET_OPERATING_DURATION,
      symbol: COIN_NAME_SFL,
      data: { _duration: re },
    };
    await this.handleContractCall(obj);
  }

  // 최소금액
  async setMinFundraisingAmount(aMinAmt: string) {
    const obj: ContractCallType = {
      method: METHOD_SET_MIN_FUNDRAISING_AMOUNT,
      symbol: COIN_NAME_SFL,
      data: { _amount: aMinAmt },
    };
    await this.handleContractCall(obj);
  }
  // 최대금액
  async setMaxFundraisingAmount(aMaxAmt: string) {
    const obj: ContractCallType = {
      method: METHOD_SET_MAX_FUNDRAISING_AMOUNT,
      symbol: COIN_NAME_SFL,
      data: { _amount: aMaxAmt },
    };
    await this.handleContractCall(obj);
  }
  // 토큰 주소???
  async setStakingToken(aTokenAddr: string) {
    const obj: ContractCallType = {
      method: METHOD_SET_STAKING_TOKEN,
      symbol: COIN_NAME_SFL,
      data: { _tokenAddress: aTokenAddr },
    };
    await this.handleContractCall(obj);
  }
  // 모금 중지
  async stopFundraising() {
    const obj: ContractCallType = {
      method: METHOD_STOP_FUNDRAISING,
      symbol: COIN_NAME_SFL,
    };
    await this.handleContractCall(obj);
  }
}
